.loadingPlaceholder > div {
    height: 300px;
}